// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"892af230","239":"be0d2136","667":"f82eee15"}[chunkId] + ".chunk.js";
};